import { createAction } from '@reduxjs/toolkit';
import { VideoSource } from '../../../VideoSource/VideoSource';

const setVideoSource = createAction<VideoSource>('VIDEO_STORE_SET_VIDEO_SOURCE');

export default {
  setVideoSource
};
